// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import NewsRow from 'components/fragments/NewsRow';
import { formatFullDate, getDateFromString } from 'utils/dateUtils';
import type { ArticleType } from 'types/Article';

type Props = {
  articles: Array<ArticleType>,
  slug: string,
  label: string
};

class FooterArticle extends PureComponent<Props> {
  props: Props;

  renderArticles = (): any => {
    const { articles } = this.props;
    return articles.map((article, index) => {
      if (index < 4) {
        return (
          <NewsRow
            key={article.title}
            slug={article.slug}
            categorySlug={article.label.slug}
            img={article.illustration}
            title={article.title}
            date={formatFullDate(getDateFromString(article.date))}
          />
        );
      }

      return null;
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="box block-news mb-6 mb-md-7 mb-lg-8">
            <Link
              to={`/actualites/${this.props.slug}`}
              title={`Lire l'intégralité de l'actualité de la catégorie : ${this.props.label}`}
              className="link-chevron link-chevron--right"
              data-label=""
            >
              <span>Voir plus</span>
              <i className="icon icon-chevron-right" />
            </Link>
            <h3 className="mb-3">Actualités dans {this.props.label}</h3>
            {this.renderArticles()}
          </div>
        </div>
      </div>
    );
  }
}

export default FooterArticle;
